// React/Next imports
import { useRouter } from 'next/router';

// Hooks
import useUser from '@/utils/hooks/swr/useUser';
import useAcl from '@/utils/hooks/user/useAcl';
import useDarkMode from '@/utils/hooks/utils/useDarkMode';

// Types
import type { WrapperPlatformProps } from '@/components/layouts/wrappers/WrapperPlatform';

// Constants/Libs
import { aclTemporaryFeatures } from '@/lib/acl/aclFeatures';

// Components
import WrapperLogged from '@/components/layouts/wrappers/WrapperLogged';
import { WrapperPlatform } from '@/components/layouts/wrappers/WrapperPlatform';
import LoaderPage from '@/components/base/Loader/LoaderPage';

type WrapperSwitchLayoutProps = Pick<WrapperPlatformProps, 'noPadding' | 'disableMainScroll'> & {
    className?: string;
    bodyWrapperClass?: string;
    children: React.ReactNode;
};

export function WrapperSwitchLayout({
    noPadding = false,
    disableMainScroll = false,
    bodyWrapperClass,
    className,
    children
}: WrapperSwitchLayoutProps) {
    const router = useRouter();
    const { isLoading, userError } = useUser();
    const { hasAcl } = useAcl();
    const { useAddDarkMode } = useDarkMode();
    useAddDarkMode();

    if (userError || isLoading) {
        if (userError) {
            router.push('/');
        }

        return <LoaderPage />;
    }

    if (!hasAcl(aclTemporaryFeatures.front.tree_structure.read)) {
        return <WrapperLogged bodyWrapperClass={bodyWrapperClass}>{children}</WrapperLogged>;
    }

    return (
        <WrapperPlatform
            className={className}
            noPadding={noPadding}
            disableMainScroll={disableMainScroll}>
            {children}
        </WrapperPlatform>
    );
}
